import { styled } from '@mui/material/styles'

import { GridWrapper } from '../wrapper'

export const GridPartialScreen = styled(GridWrapper)(() => ({
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-around'
}))
